export enum EAccountType {
    CHECKING_ACCOUNT = 'checking_account',
    SAVINGS_ACCOUNT = 'savings_account',
    CASH_ACCOUNT = 'cash_account',
    CREDIT_CARD_ACCOUNT = 'credit_card_account',
    DIGITAL_ACCOUNT = 'digital_account',
}

export enum EInitialBalanceType {
    CREDIT = 1,
    DEBIT = 2,
}

export enum EFinancialPixKey {
    DOCUMENT = 'document',
    PHONE = 'phone',
    EMAIL = 'email',
    RANDOM = 'random',
}
